import NOAATides from '../services/NOAATides'

import {
  REQUEST_TIDES,
  RECEIVE_TIDES
} from './'



// ===================
// = Action creators =
// ===================






// Request
function requestTides(stationId, range) {
  return {
    type: REQUEST_TIDES,
    stationId,
    range
  }
}


// Receive
function receiveTides(stationId, range, tides) {
  return {
    type: RECEIVE_TIDES,
    stationId,
    range,
    tides
  }
}


// Fetch
// function shouldFetchTides(state, stationId, range) {
//   const stationTides = state.tidesByStationId[stationId]
//
//   if (!stationTides)
//     return true
//
//   stationTides.ranges.some(rangeObj => {
//     return range.isSame(rangeObj.range)
//   })
// }


function existingRangeReducer(fetchableRanges, existingRange) {
  let newFetchableRanges = []
  fetchableRanges.forEach(fetchableRange => {
    const result = fetchableRange.subtract(existingRange.range)
    newFetchableRanges = newFetchableRanges.concat(result)
  })
  return newFetchableRanges
}
function subtractExistingRanges(state, stationId, range) {
  performance.mark('subtr-start')
  const stationTides = state.tidesByStationId[stationId]
  if (!stationTides) return [range]

  const existingRanges  = stationTides.ranges
  const fetchableRanges = [range.clone()]

  const result = existingRanges.reduce(
    existingRangeReducer, fetchableRanges
  )

  performance.mark('subtr-end')
  performance.measure('subtr', 'subtr-start', 'subtr-end')

  return result
}


function fetchTides(stationId, range) {
  return function(dispatch, getState) {
    dispatch(requestTides(stationId, range))
    NOAATides.getTides(stationId, range)
    .then(
      tides => {
        dispatch(receiveTides(stationId, range, tides))
      },
      error => {
        console.warn('getTides ERROR. Need to handle this correctly', error)
      }
    )
  }
}

export function fetchTidesIfNeeded(stationId, range) {
  return function(dispatch, getState) {
    const fetchableRanges = subtractExistingRanges(
      getState(), stationId, range
    )
    fetchableRanges.forEach(range => {
      console.log('FETCHING...', range.toString())
      dispatch(fetchTides(stationId, range))
    })
  }
}


window.fetchTides = fetchTides
window.fetchTidesIfNeeded = fetchTidesIfNeeded



// WEBPACK FOOTER //
// ./src/actions/tidesActions.js